import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { SetHomePopup } from './SetHomePopup';
import {
  UserConfigContext,
  PROPERTIES,
  getContextFromHomeScreenValue,
} from './../UserConfig';
import { UserContext } from '../UserContext';

const useStyles = makeStyles((theme) => ({
  iconGrid: {
    alignSelf: 'center',
    textAlign: 'end',
    paddingRight: 16,
  },
  updateButton: {
    backgroundColor: '#cddff3',
    color: '#4C94EC',
    textTransform: 'inherit',
    height: 30,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    borderRadius: 4,
  },
}));
export const SetHomeButton = (props) => {
  const { context } = props;
  const { user } = useContext(UserContext);
  const isSiaaAgency = user.isSiaaAgency();
  const [open, setOpen] = useState(false);
  const { getProperty } = useContext(UserConfigContext);
  const homeScreen = getProperty(PROPERTIES.HOME_SCREEN);
  const homeScreenContext = getContextFromHomeScreenValue(homeScreen);
  const visible = false;
  const classes = useStyles();
  return (
    <>
      {visible && (
        <>
          <SetHomePopup
            open={open}
            onClose={() => {
              setOpen(false);
            }}
            context={context}
          />
          <Grid item className={classes.iconGrid}>
            <Button
              className={classes.updateButton}
              onClick={() => setOpen(true)}
            >
              Set As Home
            </Button>
          </Grid>
        </>
      )}
    </>
  );
};

SetHomeButton.propTypes = {
  context: PropTypes.string.isRequired,
};
